import recordsAPI from './recordsAPI';

const recordVideoDetailEndpoint = (recordCategoryId, recordTypeId, recordDetailId) =>
    '/site/api/record-video-detail' +
    `?cayenneExp=recordCategoryId=${recordCategoryId}` +
    ` and recordTypeId=${recordTypeId}` +
    ` and recordDetailId=${recordDetailId}`;

const getVideoDetailsMapFromRecord = async (fetch, record) => {
    if (!record) {
        return {};
    }

    const { recordCategory, recordType, id } = record;
    const { data: videoDetails } = await fetch(recordVideoDetailEndpoint(recordCategory.id, recordType.id, id));
    return videoDetails.data.reduce((acc, v) => {
        acc[v.recordId] = v;
        return acc;
    }, {});
};

const getVideoDetailsMapFromKeys = async (fetch, recordCategoryKey, recordTypeKey = null) => {
    const { data: recordData } = await fetch(recordsAPI.recordDetailsEndpoint(recordCategoryKey, recordTypeKey));
    const detailMap = await getVideoDetailsMapFromRecord(fetch, recordData.data?.[0]);
    return detailMap;
};

const addVideoIdToDataset = (data, videoDetailMap, accessor?) => {
    data.forEach((e) => {
        const value = accessor ? accessor(e) : e.id;
        if (videoDetailMap[value]) {
            e.videoId = videoDetailMap[value].videoId;
        }
    });
    return data;
};

export default {
    getVideoDetailsMapFromRecord,
    getVideoDetailsMapFromKeys,
    addVideoIdToDataset,
};
